import Signal from "./utils/Signal";

class GD{
    static S_MENU_SELECT:Signal<string>=new Signal()
    static S_LOGO_CLICK:Signal<void>=new Signal()
}
export default GD;